import React from 'react';
import {
    EuiHeader,
    EuiHeaderSectionItem,
    EuiHeaderLinks,
    EuiHeaderLink,
} from '@elastic/eui';
class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            position: 'fixed',
            color: "white"
        }
    }

    componentDidMount() {
        if(window.innerWidth<700){
            this.setState({
                color: "black"
            })
        }
    }

    render() {
        const renderLogo = (
            <><EuiHeaderLink href="/about" style={{color:'white'}}><b><font face="Courier New">Nikhil Pawar</font></b></EuiHeaderLink></>
        );

        // const renderTitle = (
        //     <EuiHeaderSectionItemButton>
        //         <EuiText textAlign='center'><h2><font face='Courier New' >Finalytics</font></h2></EuiText>
        //     </EuiHeaderSectionItemButton>
        // )
    
        const renderUser = (
            <EuiHeaderSectionItem border='none'>
                <EuiHeaderLinks><h7>
                    <EuiHeaderLink size='xs' href="/about" style={{color:this.state.color}}>About Me</EuiHeaderLink>
                    <EuiHeaderLink size='xs' href="/research" style={{color:this.state.color}}>Research</EuiHeaderLink>
                    <EuiHeaderLink size='xs' href="/publications" style={{color:this.state.color}}>Publications</EuiHeaderLink>
                    <EuiHeaderLink size='xs' href="/work" style={{color:this.state.color}}>Work Experience</EuiHeaderLink>
                    <EuiHeaderLink size='xs' href="/education" style={{color:this.state.color}}>Education</EuiHeaderLink>
                    <EuiHeaderLink size='xs' href="/mentoring" style={{color:this.state.color}}>Mentoring</EuiHeaderLink>
                    <EuiHeaderLink size='xs' href="/people" style={{color:this.state.color}}>People</EuiHeaderLink>
                    <EuiHeaderLink size='xs' href="/contact" style={{color:this.state.color}}>Contact</EuiHeaderLink></h7>
                </EuiHeaderLinks>
            </EuiHeaderSectionItem>
        );
    
        const sections = [
            {
                items: [renderLogo],
                borders: 'right',
            },
            {
                items: [renderUser]
            },]

        return (
            <>
                <EuiHeader position={ this.state.position } sections={ sections } style={{backgroundColor: '#2774AE'}} />
            </>
        );
    }
}

export { Header }